import {
  ExchanegeRateService,
  PagedResponse_ExchangeRateRangeListResponse,
  PagedResponse_RecommendedRateResponse,
} from '@acme/api';
import { ExchangeRateFilter, RecommendedRateFilter } from './types';

class ExchangeRateStore {
  private exchangeRates: PagedResponse_ExchangeRateRangeListResponse | null =
    null;

  private loadingPromise: Promise<PagedResponse_ExchangeRateRangeListResponse> | null =
    null;
  private recommendedExchangeRates: PagedResponse_RecommendedRateResponse | null =
    null;
  private recommendedLoadingPromise: Promise<PagedResponse_RecommendedRateResponse> | null =
    null;
  private error: Error | null = null;

  async getExchangeRates(
    filter: ExchangeRateFilter
  ): Promise<PagedResponse_ExchangeRateRangeListResponse> {
    this.loadingPromise = (async () => {
      try {
        const response =
          await ExchanegeRateService.getApiV1ExchanegeRateList(filter);
        if (!response.data) {
          throw new Error('No data received from exchange rates API');
        }
        this.exchangeRates = response.data;
        return this.exchangeRates;
      } catch (err) {
        this.error =
          err instanceof Error
            ? err
            : new Error('Failed to load exchange rates');
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();

    return this.loadingPromise;
  }

  async getRecommendedExchangeRates(
    filter: RecommendedRateFilter
  ): Promise<PagedResponse_RecommendedRateResponse> {
    if (this.recommendedExchangeRates) {
      return this.recommendedExchangeRates;
    }

    if (this.recommendedLoadingPromise) {
      return this.recommendedLoadingPromise;
    }

    this.recommendedLoadingPromise = (async () => {
      try {
        const response =
          await ExchanegeRateService.getApiV1ExchanegeRateRecommended(filter);
        if (!response.data) {
          throw new Error('No data received from exchange rates API');
        }
        this.recommendedExchangeRates = response.data;
        return this.recommendedExchangeRates;
      } catch (err) {
        this.error =
          err instanceof Error
            ? err
            : new Error('Failed to load recommended exchange rates');
        throw this.error;
      } finally {
        this.recommendedLoadingPromise = null;
      }
    })();

    return this.recommendedLoadingPromise;
  }
}

export const exchangeRateStore = new ExchangeRateStore();
